/**
 * Format file size in bytes to human readable format
 * @param {number} bytes - File size in bytes
 * @param {number} decimals - Number of decimal places to show
 * @returns {string} Formatted file size string
 */
export const formatFileSize = (bytes, decimals = 2) => {
  if (!bytes || bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

/**
 * Get file extension from filename
 * @param {string} filename - The filename
 * @returns {string} File extension in lowercase
 */
export const getFileExtension = filename => {
  if (!filename) return "";
  return filename.split(".").pop()?.toLowerCase() || "";
};

/**
 * Check if file is an image based on extension
 * @param {string} filename - The filename
 * @returns {boolean} True if file is an image
 */
export const isImageFile = filename => {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  return imageExtensions.includes(getFileExtension(filename));
};

/**
 * Check if file is a document based on extension
 * @param {string} filename - The filename
 * @returns {boolean} True if file is a document
 */
export const isDocumentFile = filename => {
  const documentExtensions = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "rtf"];
  return documentExtensions.includes(getFileExtension(filename));
};
